import React, { Component } from 'react'
import moment from 'moment'

const dateFormat = 'YYYY/MM/DD HH:mm'

class PublicIssueFullTable extends Component {
    render() {
        return (
            <table style={{textAlign: 'left', verticalAlign: 'top'}}>
                <tbody>
                    <tr>
                        <th style={{minWidth: '120px'}}>Tipo de Deteção</th>
                        <td>{this.props.data.issue_detection === 1 ? 'Aviso/Chamada': 'Visita Regular'}</td>
                    </tr>
                    <tr>
                        <th>ID do Registo</th><td>{this.props.data.id}</td>
                    </tr>
                    <tr>
                        <th>Programa</th><td>{this.props.data.programa}</td>
                    </tr>
                    <tr>
                        <th>Local</th><td>{this.props.data.address}</td>
                    </tr>
                    <tr>
                        <th>Praia</th><td>{this.props.data.praia}</td>
                    </tr>
                    <tr>
                        <th>Freguesia</th><td>{this.props.data.freguesia}</td>
                    </tr>
                    <tr>
                        <th>Concelho</th><td>{this.props.data.concelho}</td>
                    </tr>
                    <tr>
                        <th>Distrito</th><td>{this.props.data.distrito}</td>
                    </tr>
                    <tr>
                        <th>ARH</th><td>{this.props.data.arh}</td>
                    </tr>
                    <tr>
                        <th>Latitude (Web Mercator, EPSG:3857)</th><td>{this.props.data.lat}</td>
                    </tr>
                    <tr>
                        <th>Longitude (Web Mercator, EPSG:3857)</th><td>{this.props.data.lon}</td>
                    </tr>
                    <tr>
                        <th>Data da Ocorrência</th>
                        { this.props.data.data_ocorrencia_tipo === 0 ? (
                          <td>{moment(this.props.data.data_ocorrencia).format(dateFormat)}</td>
                        ) : (
                            <td><em>Indeterminada</em></td>
                        ) }
                    </tr>
                    <tr>
                        <th>Data do Registo</th><td>{moment(this.props.data.data_registo_local).format(dateFormat)}</td>
                    </tr>

                    { this.props.data.id ? (
                        <tr>
                            <th>Data do Registo no Sistema</th>
                            <td>{moment(this.props.data.data_registo).format(dateFormat)}</td>
                        </tr>
                    ) : null}

                    { this.props.data.user.indexOf('public_') === -1 ? (
                        <tr>
                            <th>Utilizador</th><td>{this.props.data.user}</td>
                        </tr>

                    ) : null}

                    <tr>
                        <th>Email</th><td>{this.props.data.email}</td>
                    </tr>

                    { this.props.data.user.indexOf('public_') === -1 ? (
                        <tr>
                            <th>Entidade</th><td>{this.props.data.entidade}</td>
                        </tr>
                    ) : null}
                    <tr>
                        { this.props.data.type_a ? (<th>a. Instabilidade em arribas</th>) : null }
                        { this.props.data.type_a ? (
                            <td>
                                { this.props.data.type_ai ? (
                                    <p>i. Movimento de massa de vertente (MMV)<br />Alcance máximo do depósito/detritos: {this.props.data.type_ai_meters} metros</p>
                                ) : null}
                                { this.props.data.type_aii ? (
                                    <p>ii. Fenda de tração com cobertura visivel: Sim</p>
                                ) : null}
                            </td>
                        ) : null }
                    </tr>
                    <tr>
                        { this.props.data.type_b ? (<th>b. Erosão/recuo da linha de costa</th>) : null }
                        { this.props.data.type_b ? (
                            <td>
                                { this.props.data.type_bi ? (
                                    <p>i. Escarpamento da duna<br />Altura máxima da escarpa: {this.props.data.type_bi_meters} metros</p>
                                ) : null}
                                { this.props.data.type_bii ? (
                                    <p>ii. Rebaixamento da praia<br />Altura máxima: {this.props.data.type_bii_meters} metros</p>
                                ) : null}
                            </td>
                        ) : null }
                    </tr>
                    <tr>
                        { this.props.data.type_c ? (<th>c. Dano em obra/estrutura de proteção costeira</th>) : null }
                        { this.props.data.type_c ? (<td>Sim</td>) : null }
                    </tr>
                    <tr>
                        { this.props.data.type_d ? (<th>d. Galgamento costeiro</th>) : null }
                        { this.props.data.type_d ? (
                            <td>Alcance máximo da água/detritos: {this.props.data.type_d_meters} metros</td>
                        ) : null }
                    </tr>
                    <tr>
                        <th>a. Pessoas em risco</th>
                        { this.props.data.cons_a === '1' ? (<td>i. Não</td>) : null}
                        { this.props.data.cons_a === '2' ? (<td>ii. Não sabe / Não aplicável</td>) : null}
                        { this.props.data.cons_a === '3' ? (
                            <td>iii. Sim, quantidade:{' '}
                                { this.props.data.cons_aiii_qtt === 1 ? '1-10'
                                    : (this.props.data.cons_aiii_qtt === 2 ? '10-100' : '> 100')
                                }
                            </td>
                        ) : null }
                    </tr>

                    { this.props.data.cons_bii || this.props.data.cons_biii || this.props.data.cons_biv || this.props.data.cons_bv ? (
                        <tr>
                            <th>b. Danos em infra-estruturas</th>
                            <td>
                                { this.props.data.cons_bi ? (<p>i. Não</p>) : null}
                                { this.props.data.cons_bii ? (
                                    <p>ii. Sim{' '}
                                        { this.props.data.cons_bii1 ? '1. Estrutura aderente ' : null }
                                        { this.props.data.cons_bii2 ? '2. Esporão/quebra-mar ' : null }
                                        { this.props.data.cons_bii3 ? '3. Obra de proteção/estabilização de Arriba' : null }
                                    </p>
                                ) : null }
                                { this.props.data.cons_biii ? (<p>iii. Áreas construídas de fruição/uso público (e.g. passeio pedonal/passadiços/miradouro/zonas estadia)</p>) : null }
                                { this.props.data.cons_biv ? (<p>iv. Edificações (e.g. habitações/comerciais/apoios de praia)</p>) : null }
                                { this.props.data.cons_bv ? (<p>v. Outras</p>) : null }
                            </td>
                        </tr>
                    ) : (
                        <tr>
                            <th>b. Danos em infra-estruturas</th>
                            <td>i. Não</td>
                        </tr>
                    ) }

                    <tr>
                        <th>Medidas de mitigação ou minimização do risco</th>
                        <td>
                            { this.props.data.miti === '1' ? (<p>i. Não</p>) : null}
                            { this.props.data.miti === '2' ? (<p>ii. Não sabe / Não aplicável</p>) : null}
                            { this.props.data.miti === '3' ? (
                                <div>
                                    <p>iii. Sim</p>
                                    { this.props.data.miti_c_i ?
                                        (<p>i. Sinalização (aviso/interdição) {this.props.data.miti_c_i === 'i' ? ' - Imediata' : ' - A adotar' }</p>)
                                        : null
                                    }
                                    { this.props.data.miti_c_ii ?
                                        (<p>ii. Delimitação/interdição de área de risco {this.props.data.miti_c_ii === 'i' ? ' - Imediata' : ' - A adotar' }</p>)
                                        : null
                                    }
                                    { this.props.data.miti_c_iii ?
                                        (<p>iii. Saneamento de blocos/reperfilamento {this.props.data.miti_c_iii === 'i' ? ' - Imediata' : ' - A adotar' }</p>)
                                        : null
                                    }
                                    { this.props.data.miti_c_iv ?
                                        (<p>iv. Reabilitação de obra de proteção/estabilização {this.props.data.miti_c_iv === 'i' ? ' - Imediata' : ' - A adotar' }</p>)
                                        : null
                                    }
                                    { this.props.data.miti_c_v ?
                                        (<p>v. Reforço/Alimentação artificial de emergência {this.props.data.miti_c_v === 'i' ? ' - Imediata' : ' - A adotar' }</p>)
                                        : null
                                    }
                                </div>
                            ) : null }
                        </td>
                    </tr>

                    { this.props.data.obs ? (
                        <tr>
                            <th>Observações</th>
                            <td>{this.props.data.obs}</td>
                        </tr>
                    ) : null }

                </tbody>
            </table>
        )
    }
}

export default PublicIssueFullTable;



// WEBPACK FOOTER //
// ./src/components/PublicIssueFullTable.js